import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { useFormik } from "formik";
import toast from "react-hot-toast";

import * as SVGImages from "../../svg";

import "../Asociados/createAsociados.css";
import "./createAbono.css";
import { createOrdenFormValidation } from "../../../../helper/validate";

import * as api from "helper/helper";
import "./../formsCommons.css";

import { EstadoBodega } from "../../../../helper/const";
import { buildNameWithId, Singleton } from "helper/tools";

import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";

import { format } from "date-fns";
import SkeletonTable from "../Skeleton/SkeletonTable";

const PagosModal = forwardRef(({ item, reloadOrdenes }, ref) => {
  const modalRef = useRef();
  const buttonCancelModalRef = useRef();
  const asociadoIdRef = useRef(0);

  /// CHECAR  useTraceUpdate(props, "CreateOrdenVenta");
  const [isActiveDisabled, setIsActiveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [asociados, setAsociados] = useState([]);

  const [roles, setRoles] = useState([]);
  const [ordenSubtotal, setOrdenSubtotal] = useState(0);
  const [ordenDescuento, setOrdenDescuento] = useState(0);

  const [ordenTotal, setOrdenTotal] = useState(0);

  const [creditoSuperado, setCreditoSuperado] = useState(false);
  const [asociadoCongelado, setAsociadoCongelado] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const createMode = item == null || (item && Object.keys(item).length === 0);

  useEffect(() => {
    console.log("---> change item: " + item);
    let isActiveDisable = createMode;
    setIsActiveDisabled(isActiveDisable);

    setOrdenDescuento([]);

    setOrdenSubtotal(0);
    setOrdenTotal(0);

    formik?.resetForm();

    loadItem(item);
  }, [item]);

  const fetchData = async () => {
    const response = await api.asociados().catch((e) => {
      toast.error("Error al pedir asociados.");
    });
    if (!response) return;

    const autoAsociados = response.data.map((item) => {
      const text = buildNameWithId(item, item.numAsociado);
      return { id: item.id, nombre: text, info: item };
    });

    setAsociados(autoAsociados);

    api
      .tiposEntrega()
      .then((response) => {
        setRoles([
          { id: 0, nombre: "Selecciona un Tipo de Entrega..." },
          ...response.data,
        ]);

        console.log(response.status);
      })
      .catch((e) => {
        console.log(e); // "oh, no!"
      });

    console.log(response.status);
  };

  useEffect(() => {
    formik?.resetForm();

    fetchData();

    const newPermissions = PermissionsForSection(Sections.Clientes);
    setPermissions(newPermissions);
  }, []);

  let initialValues = {
    id: 0,

    apartado: false,

    clienteId: null,
    asociadoId: 0,

    tipoEntregaId: 1,
    subTotalVenta: 0,
    descuento: 0,
    totalVenta: 0,
    ordenVentaDetalles: [],

    cantidad: 0,
  };

  if (!createMode) {
    initialValues = {
      id: item.id,

      clienteId: item.itemCliente?.cliente?.id,
      asociadoId: item.asociado.id,
    };
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: createOrdenFormValidation,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { props, setSubmitting }) => {
      if (values.clienteId === 0) values.clienteId = null;

      // normalize
      const ordenVentaDetalles = [].map((item) => {
        return {
          ordenVentaId: 0,
          productoId: item.id,
          cantidad: item.cantidad,
          precio: item.precio,
          total: item.total,
          subTotal: item.subTotal,
          descuento: item.descuento,
          promocionId: item.promocionId,
        };
      });

      values.totalVenta = ordenTotal;
      values.subTotalVenta = ordenSubtotal;

      values.ordenVentaDetalles = ordenVentaDetalles;

      /* default es En proceso Id = 1
      apartado = 2
      */
      const estadoBodegaId = formik.values.apartado
        ? EstadoBodega.Apartado
        : EstadoBodega.EnProceso;
      values.estadoBodegaId = estadoBodegaId;

      if (values.id === 0) {
        setIsLoading(true);
        const toastId = toast.loading("Creando Orden de Venta...");
        let response = await api.createOrdenVenta(values).catch((e) => {
          toast.dismiss(toastId);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al Orden de Venta. ${e.mensaje}`);
            setIsLoading(false);
            return;
          }
          toast.error("Error al Orden de Venta.");
          setIsLoading(false);
        });

        setIsLoading(false);
        toast.dismiss(toastId);

        if (!response) return;

        toast.success("Orden de Venta creado.");
        reloadOrdenes();

        buttonCancelModalRef.current.click();
      } else {
        const toastId = toast.loading("Actualizando Orden...");
        setIsLoading(true);
        const response = await api.updateOrdenesVentas(values).catch((e) => {
          setIsLoading(false);
          toast.dismiss(toastId);
          toast.error("Error al actualizar Orden.");
        });
        if (!response) return;

        toast.dismiss(toastId);
        setIsLoading(false);

        toast.success("Orden actualizado.");
        reloadOrdenes();

        buttonCancelModalRef.current.click();
      }
    },
  });

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return formik.values;
    },
    toggleModal: () => {
      formik?.resetForm();
      modalRef.current.click();
    },
  }));

  useEffect(() => {
    validateOrder();
  }, [ordenTotal]);

  const validateOrder = () => {
    validateAsociadoCredito();
    validateAsociadoCongelado();
  };

  const validateAsociadoCongelado = () => {
    if (asociadoIdRef.current === 0) {
      setAsociadoCongelado(false);
      return;
    }

    let asociado = asociados.find((item) => item.id === asociadoIdRef.current);

    if (asociado == null) {
      return;
    }
    setAsociadoCongelado(asociado.info?.congelado ?? false);
  };

  const validateAsociadoCredito = () => {
    if (asociadoIdRef.current === 0) {
      return;
    }

    let asociado = asociados.find((item) => item.id === asociadoIdRef.current);

    if (asociado == null) {
      return;
    }

    const creditoDisponible = asociado.info?.creditoDisponible;

    const superado = ordenTotal > creditoDisponible;
    setCreditoSuperado(superado);
  };

  function loadItem(newLoadItem) {
    const isEmpty = newLoadItem && Object.keys(newLoadItem).length === 0;
    if (isEmpty) {
      return;
    }

    if (newLoadItem == null) {
      return;
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  console.log("--> CREATEORDEN Draw");
  const qtyTotal = item?.pagosCount ?? 0;
  /*
  const disponiblesText =
    formik.values.productSelected != null
      ? `Disponible ${formik.values.productSelected.option.cantidad}`
      : "Disponible - ";*/

  const theadRef = useRef();

  function handleSort(event) {}

  return (
    <>
      <button
        ref={modalRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropPagosModal"
        hidden
      >
        Abrir Crear Orden
      </button>

      <div
        className="modal fade  modal-sm"
        id="staticBackdropPagosModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropPagosModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-scrollable"
          style={{ maxWidth: "500px" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Ver Pagos Ingresados
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <form className="row g-3" onSubmit={handleSubmit}>
                <div className="form-control">
                  {creditoSuperado && (
                    <div className="alert alert-danger" role="alert">
                      El total de la orden de venta <b>supera</b> el credito
                      para el asociado.
                    </div>
                  )}
                  {asociadoCongelado && (
                    <div className="alert alert-danger" role="alert">
                      No se puede realizar una Orden de Venta a un Asociado que
                      se encuentra en Estatus Congelado
                      <span>
                        <img
                          alt=""
                          src={SVGImages.SNOWFLAKE}
                          style={{
                            width: "16px",
                            height: "16px",
                            marginLeft: "5px",
                          }}
                        />
                      </span>
                    </div>
                  )}

                  <div className="mb-3">
                    <div
                      className="row d-flex justify-content-between align-items-center"
                      style={{ fontSize: "15px" }}
                    >
                      <span style={{ flex: "1" }}>
                        Lista de pagos ({qtyTotal})
                      </span>
                      <div
                        className=""
                        style={{ display: "flex", marginBottom: "6px" }}
                      >
                        <span style={{ flex: "1" }}></span>
                        <span className="badge text-bg-success rounded-pill fs-6">
                          Total
                        </span>
                        <span
                          className="badge text-bg-primary rounded-pill  fs-6"
                          style={{ marginLeft: "6px" }}
                        >
                          Por Aplicar
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="container">
                        <table
                          className="table table-borderless datable sortable table-hover"
                          style={{ tableLayout: "fixed" }}
                        >
                          <thead
                            className="table-light"
                            style={{ textAlign: "center" }}
                          >
                            <tr ref={theadRef}>
                              {/*<th
                                          scope="col"
                                          data-column="cliente.id"
                                          style={{ width: "100px" }}
                                          onClick={(event) => handleSort(event)}
                                        >
                                          Id
                                        </th>*/}

                              <th
                                scope="col"
                                data-column="cliente.nombre"
                                onClick={(event) => handleSort(event)}
                              >
                                Fecha
                              </th>
                              <th
                                scope="col"
                                data-column="cliente.AsociadoId"
                                onClick={(event) => handleSort(event)}
                              >
                                Forma de Pago
                              </th>
                              <th
                                scope="col"
                                data-column="cliente.activo"
                                style={{ width: "100px" }}
                                onClick={(event) => handleSort(event)}
                              >
                                Total
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {isLoading && (
                              <SkeletonTable columnCount={8} rowCount={6} />
                            )}

                            {!isLoading &&
                              item?.pagos?.map((pago, index) => {
                                const pagoFecha = format(
                                  pago.fecha,
                                  "dd/MM/yy hh:mm a",
                                );
                                const formaPagoNombre =
                                  pago.formaDePago?.nombre ?? "";

                                const total = Singleton.getInstance().format(
                                  pago.total,
                                );

                                /*let totalPorAplicar = "-";
                                let opTotalPorAplicar =
                                  pago.total - pago.totalPorAplicar;
                                if (opTotalPorAplicar > 0) {
                                  totalPorAplicar =
                                    Singleton.getInstance().format(
                                      opTotalPorAplicar,
                                    );
                                }*/
                                return (
                                  <tr key={item.id}>
                                    <th
                                      scope="row"
                                      style={{
                                        verticalAlign: "middle",
                                        justifyItems: "center",
                                        textAlign: "center",
                                      }}
                                    >
                                      {pagoFecha}
                                    </th>
                                    <td>{formaPagoNombre}</td>
                                    <td>{total}</td>
                                    {/*<td>{item.correo ?? ""}</td>
                                    <td>{item.celular ?? ""}</td>
                                    <td
                                      style={{
                                        justifyContent: "center",
                                        display: "flex",
                                      }}
                                    >
                                      <ProgressRing
                                        radiusProp={25}
                                        strokeProp={6}
                                        strokeColor={"red"}
                                        progress={sum}
                                      />
                                    </td>
                                    <BadgeStatus item={item} /> */}
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>

                        <div className="valid-feedback"></div>
                        <div className="invalid-feedback">
                          {formik.errors.productosCantidad}
                        </div>
                      </div>
                      {/*QUITAR
                      <div className="container">
                        <table className="table caption-top">
                          <caption>Lista de pagos</caption>
                          <thead>
                            <tr>
                              <th scope="col">Fecha</th>
                              <th scope="col">Cantidad</th>
                              <th
                                scope="col"
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                Aplicado
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {item?.pagos?.map((pago, index) => {
                              const pagoFecha = format(
                                pago.fecha,
                                "dd/MM/yy hh:mm a",
                              );
                              const total = Singleton.getInstance().format(
                                pago.total,
                              );

                              let totalPorAplicar = "-";
                              let opTotalPorAplicar =
                                pago.total - pago.totalPorAplicar;
                              if (opTotalPorAplicar > 0) {
                                totalPorAplicar =
                                  Singleton.getInstance().format(
                                    opTotalPorAplicar,
                                  );
                              }

                              return (
                                <>
                                  <tr
                                    className={`${createOrdenStyles.tablecenter}`}
                                  >
                                    <th scope="row">{pagoFecha}</th>
                                    <td>{total}</td>
                                    <td
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      {totalPorAplicar}
                                    </td>
                                  </tr>
                                </>
                              );
                            })}

                            <tr>
                              <td
                                colSpan="2"
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bold",
                                }}
                              >
                                Cantidad Total :
                              </td>
                              <td
                                style={{
                                  width: "100px",
                                  textAlign: "center",
                                }}
                              >
                                {qtyTotal}
                              </td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>

                        <div className="valid-feedback"></div>
                        <div className="invalid-feedback">
                          {formik.errors.productosCantidad}
                        </div>
                      </div>*/}
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    ref={buttonCancelModalRef}
                  >
                    Cerrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default PagosModal;
